import React from 'react';
import EntityForm from './EntityForm';

function ManagePartyBankForm({ onChanged, selectedEntry = null, setSelectedEntry }) {
    return (
        <EntityForm
            noun="Party Bank"
            heading="Add New Party Bank"
            idKey="PartyBankID"
            insertUrl="insert_manage_party_bank"
            updateUrl="update_manage_party_bank"
            deleteUrl="delete_manage_party_bank"
            fields={[
                { name: 'name', label: 'Bank Name', entryKey: ['Name', 'name'], required: true },
                { name: 'address', label: 'Address', entryKey: ['Address', 'address'], type: 'textarea' },
                { name: 'bin', label: 'Bin No.', entryKey: ['Bin', 'bin'] },
            ]}
            selectedEntry={selectedEntry}
            setSelectedEntry={setSelectedEntry}
            onChanged={onChanged}
        />
    );
}

export default ManagePartyBankForm;
